import { freeWsDownloadLeft } from 'apps/teacher/config/common'
import { WorksheetsEnvironment } from 'printableWorksheets'
import PrintableWorksheetsEvents from 'printableWorksheets/events'
import { usePrintableWorksheetsState } from 'printableWorksheets/state'
import React, { useEffect } from 'react'
import './styles.scss'
import WSHeader from './wsHeader'
import WSList from './wsList'

const WorksheetsView = () => {

  const { defaultSearch, worksheetsEnvironment, activeGrade } = usePrintableWorksheetsState();

  const isTeacherEnvironment = worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD;

  return (
    <div className={`worksheets-view`}>
      <div className={`worksheets-view__header${!isTeacherEnvironment ? ' student' : ''}`}>
        <WSHeader hideSearch={isTeacherEnvironment} />
      </div>
      <div className={`worksheets-view__list${!defaultSearch ? ' un-focus' : ''}`}>
        <WSList />
      </div>
    </div>
  )
}

export default WorksheetsView